import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

export const useKmlData = (sessionData) => {
  const [data, setData] = useState({
    iriProfileData: null,
    elevationProfileData: null,
    markers: null // New: For Start/End coordinates
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    // Reset state when session changes
    setData({ iriProfileData: null, elevationProfileData: null, markers: null });
    setError(null);
    setLoading(false);

    const fetchOptimizedData = async () => {
      if (!sessionData?.session_id) return;

      // 1. Check if processing is complete
      if (sessionData.kml_processing_status !== 'completed' || !sessionData.profile_data_path) {
        if (sessionData.kml_processing_status === 'failed') {
          setError("Server failed to process KML data.");
        }
        return;
      }

      setLoading(true);

      try {
        // 2. Get Signed URL for the JSON file
        const { data: signedData, error: signError } = await supabase.storage
          .from('session-files')
          .createSignedUrl(sessionData.profile_data_path, 3600);

        if (signError) throw signError;

        // 3. Fetch the JSON
        const response = await fetch(signedData.signedUrl);
        if (!response.ok) throw new Error("Failed to fetch processed profile data");

        const json = await response.json();

        if (cancelled) return;

        // 4. Update State with new structure
        setData({
            iriProfileData: json.iriData,
            elevationProfileData: json.elevationData,
            // Extract markers from the 'meta' field we added in the worker
            markers: json.meta?.markers || null
        });

      } catch (err) {
        if (cancelled) return;
        console.error("Error loading optimized profile data:", err);
        setError(err.message);
      } finally {
        if (cancelled) return;
        setLoading(false);
      }
    };

    fetchOptimizedData();
    return () => {
      cancelled = true;
    };
  }, [
    sessionData?.session_id,
    sessionData?.kml_processing_status,
    sessionData?.profile_data_path
  ]);

  return { 
    kmlLoading: loading, 
    kmlError: error, 
    ...data 
  };
};
